import { _getTextWidth } from '@dynatrace/strato-components/typography';
import Typography from '@dynatrace/strato-design-tokens/typography';

export const DEFAULT_ITEM_FONT_STYLES = {
  fontSize: Typography.Text.Small.Default.Size,
  fontFamily: Typography.Text.Small.Default.Family,
  fontWeight: Typography.Text.Small.Emphasized.Weight,
};

export const getHorizontalMeasurements = (
  labelText: string,
  labelX: number,
  fontSize = Typography.Text.Small.Default.Size,
) => {
  const boxWidth = _getTextWidth(labelText, {
    ...DEFAULT_ITEM_FONT_STYLES,
    fontSize,
  });
  const textX = labelX + (labelX > 0 ? boxWidth / 2 : -boxWidth / 2);
  const boxX = textX - boxWidth / 2;

  return { boxX, boxWidth, textX };
};
